module.exports = __webpack_public_path__ + "static/science.492bdbe0.jpg";